module.exports = __webpack_public_path__ + "static/media/faceImg.43f2f631.jpg";